define(['jquery','erv_triggers'], function ($, ERVTriggers) {

	var ResponsiveFooter = function ($footerLinkListTriggers) {
		var self = this;
		self.triggers = new ERVTriggers();

		ResponsiveFooter.prototype.addEventListener = function () {
			self.triggers.initTogglers('.nav');
		}

		ResponsiveFooter.prototype.removeEventListener = function () {
			$footerLinkListTriggers.each(function () {
				var $trigger = $(this),
					$parent = $trigger.parent();

				$parent.removeClass('is-expanded');
				$trigger.removeClass('arrow');

				$trigger.unbind();
			});
		}
	};

	return ResponsiveFooter;
});